import React, {useState, useEffect} from 'react';
import cookie from 'react-cookies';
import styled from "styled-components";
import ModalLayout from "@layouts/modal";
import {UserContext, UserDispatcherContext} from "@providers/user";
import {sendVerificationCode, loginByVerificationCode, loginByPassword, register} from "@models/auth";
import {getUsernameInfo} from '@models/username_info';
import Code from "./code";
import SignUpType from "./type";
import SignUpRealtor from "./realtor";
import Captcha from "./captcha";
import {toEnglishNumber} from "@helpers/numbers";
import {isEmpty} from "@helpers/helpers";
import Validation from "@utils/validator";
import ButtonBase from "@atoms/button.base";
import ButtonTransparent from "@atoms/button.transparent";
import Icon from "@atoms/icon";
import RightArrowIcon from '@icons/arrow-right.svg';
import EyeIcon from '@icons/eye.svg';
import EyeCloseIcon from '@icons/eye-close.svg';
import CircleLoading from "../lotties/circle_loading";
import {formatToPhone} from "../../helpers/numbers";
import {str_replace} from "../../helpers/helpers";
import {isAgency, isRealtor} from "../../../models/user";
import ConfirmCaptcha from "./confirm_captcha";

const FormFields = {
    mobile: {value: '', error: '', loading: false},
    email: {value: '', error: '', loading: false},
    password: {value: '', error: '', loading: false},
    code: {value: '', error: '', loading: false},
    sing_up_type: {value: '', error: '', loading: false},
    sign_up_realtor: {
        value: {
            city_id: "",
            district_id: "",
            name: "",
            agency_name: "",
        },
        error: '',
        loading: false
    },
    captcha: {token: '', require: false, value: '', error: ''},
    captcha_code: {value: '', error: ''},
    confirm_captcha: {value: '', error: '', loading: false},
};

const FormLevel = {
    mobile: true,
    email: false,
    password: false,
    code: false,
    sing_up_type: false,
    sign_up_realtor: false,
    confirm_captcha: false,
};

function Login({show, setShow, className, setForceShowBtnCreate, callback = undefined}) {
    const userDispatcherContext = React.useContext(UserDispatcherContext);
    const userContext = React.useContext(UserContext);
    const [userExist, setUserExist] = useState(true);
    const [userType, setUserType] = useState('');
    const [userName, setUserName] = useState('mobile');
    const [fields, setFields] = useState(FormFields);
    const [level, setLevel] = useState(FormLevel);
    const [passwordType, setPasswordType] = useState('password');
    const [verificationCodeLoading, setVerificationCodeLoading] = useState(false);

    // TODO:: this useEffect function is for check login after coming from laravel
    useEffect(() => {
        if (userContext.check || (!userContext.check && !isEmpty(cookie.load('auth_token')))) {
            setTimeout(() => {
                if (userContext.check) {
                    //navbarForceUpdate()
                }
            }, 1500);
        }
    }, []);
    // ./

    useEffect(() => {
        setFields(FormFields);
        setLevel(FormLevel);
        if (typeof setForceShowBtnCreate !== "undefined") {
            setForceShowBtnCreate(false);
        }
    }, [show]);

    /*
    * Enter key event
    * */
    useEffect(() => {
        const handleUserKeyPress = (event) => {
            const {key, keyCode} = event;
            if (show && keyCode === 13) {
                if (level.mobile) {
                    checkUserName();
                } else if (level.email) {
                    checkUserName('email');
                } else if (level.password) {
                    handleLoginByPassword();
                }
            }
        };
        window.addEventListener('keydown', handleUserKeyPress);
        return () => {
            window.removeEventListener('keydown', handleUserKeyPress);
        };
    });

    const handleContinue = (to_level) => {

        if (to_level === 'mobile' || to_level === 'email') {
            setUserName(to_level);
        }

        setLevel({
            mobile: (to_level === 'mobile'),
            email: (to_level === 'email'),
            password: (to_level === 'password'),
            code: (to_level === 'code'),
            sing_up_type: (to_level === 'sing_up_type'),
            sign_up_realtor: (to_level === 'sign_up_realtor'),
            confirm_captcha: (to_level === 'confirm_captcha'),
        });

        setFields(state => ({
            ...state,
            [to_level]: {value: fields[to_level]['value'], error: '', loading: false},
        }));
    };

    const handleChange = (e) => {
        const target = e.target;
        let {name, value} = target;
        value = str_replace(' ', '', value);
        value = toEnglishNumber(value);

        if (name === 'mobile') {
            const number_regexp = /^[0-9\b]+$/;
            value = number_regexp.test(value) ? value : '';
        }

        let new_value = {value: value, error: '', loading: false};
        if (name === 'captcha') {
            new_value = {token: fields.captcha.token, require: fields.captcha.require, value: value, error: ''}
        }

        setFields(state => ({
            ...state,
            [name]: new_value
        }));
    };

    const getVerificationCode = (to_level, data, username, usernameValue, isCodeStep = false) => {

        setFields(state => ({
            ...state,
            [username]: {value: usernameValue, error: '', loading: false},
            ['code']: {value: '', error: '', loading: false},
            ['captcha']: {token: '', require: false, value: '', error: ''}
        }));

        sendVerificationCode(data).then(result => {

            handleContinue(to_level);

            setVerificationCodeLoading(false);
        }).catch(err => {
            setVerificationCodeLoading(false);

            if (!isEmpty(err) && !isEmpty(err.response)) {
                const errors = err.response.data;

                if (!isEmpty(errors.captcha_token)) {

                    if (isCodeStep) {
                        handleContinue('confirm_captcha');
                    }

                    setFields(state => ({
                        ...state,
                        ['captcha']: {token: errors.captcha_token, require: true},
                        ['code']: {value: '', error: '', loading: false}
                    }));
                } else {
                    handleContinue(username);

                    setFields(state => ({
                        ...state,
                        [username]: {value: usernameValue, error: 'مقدار وارد شده اشتباه است.', loading: false},
                        ['code']: {value: '', error: '', loading: false},
                        ['captcha']: {token: '', require: false, value: '', error: ''}
                    }));
                }
            }
        })
    };

    const handleVerificationCode = (to_level = 'code', isCodeStep = false) => {
        setVerificationCodeLoading(true);
        const usernameSelected = getUsername();
        const data = (!isEmpty(fields.mobile.value)) ? {mobile: fields.mobile.value, captcha_code: fields.captcha.value} : {email: fields.email.value, captcha_code: fields.captcha.value};

        getVerificationCode(to_level, data, usernameSelected.username, usernameSelected.value, isCodeStep);
    };

    const checkUserName = (username = 'mobile') => {
        const second_username = (username === 'mobile') ? 'email' : 'mobile';
        const value = (typeof fields[username] !== "undefined") ? fields[username].value : '';

        const rules = (username === 'mobile') ? {mobile: 'required|mobile'} : {email1: 'required|email'};
        const data = (username === 'mobile') ? {mobile: value, captcha_code: fields.captcha.value} : {email1: value, captcha_code: fields.captcha.value};
        const validator = Validation(data, rules);
        validator.setAttributeNames((username === 'mobile') ? {mobile: 'موبایل‌تون'} : {email1: 'ایمیل‌تون'});

        if (validator.fails()) {
            const error = validator.errors.first(((username === 'email') ? 'email1' : 'mobile'));

            setFields(state => ({
                ...state,
                [username]: {value: value, error: error, loading: false},
                [second_username]: {value: '', error: '', loading: false}
            }));
        } else {
            setFields(state => ({
                ...state,
                [username]: {value: value, error: '', loading: true},
                [second_username]: {value: '', error: '', loading: false}
            }));

            getUsernameInfo(value).then(result => {
                if (result.isAdmin) {
                    window.location.href = '/admin/login';
                } else if (result.isSuspended) {
                    setFields(state => ({
                        ...state,
                        [username]: {value: value, error: 'حساب کاربری شما غیرفعال شده! اگه فکر می‌کنید اشتباهی رخ داده؛ لطفا با پشتیبانی ۲نبش (02191015474) تماس بگیرید.', loading: false},
                    }));
                } else if (result.userExists) {
                    setUserExist(true);
                    setUserType(result.userType);

                    if (result.userType === 'agent' || (result.usernameVerified && result.userHasPassword)) {
                        handleContinue('password');
                    } else {
                        getVerificationCode('code', data, username, value);
                    }
                } else {
                    setUserExist(false);
                    if (username === 'mobile') {
                        handleContinue('sing_up_type');
                    } else {
                        setFields(state => ({
                            ...state,
                            ['email']: {value: value, error: 'کاربری با این ایمیل وجود نداره.', loading: false},
                        }));
                    }
                }
            }).catch(err => {
                setFields(state => ({
                    ...state,
                    [username]: {value: value, error: 'خطا در سرور، دوباره تلاش کنید.'}
                }));
            });
        }
    };

    const getUsername = () => {
        return {
            username: (!isEmpty(fields.mobile.value)) ? 'mobile' : 'email',
            value: (!isEmpty(fields.mobile.value)) ? fields.mobile.value : fields.email.value
        }
    };

    const redirectToPanel = (user) => {
        const is_realtor = isRealtor(user);
        const is_agency = isAgency(user);

        if (is_agency || is_realtor) {
            setTimeout(function () {
                window.location.href = '/panel';
            }, 600);
        }
    };

    const loginByCode = (code) => {
        const username = getUsername().value;
        const verification_code = code;
        const captcha_code = fields.captcha.value;

        loginByVerificationCode(username, verification_code, captcha_code).then(result => {
            userDispatcherContext({
                type: 'STORE_USER',
                payload: {
                    token: result.auth_token,
                    user: result.user
                },
            });

            setShow(false);

            if (!isEmpty(callback)) {
                callback(true);
            } else {
                redirectToPanel(result.user)
            }
        }).catch(err => {
            if (!isEmpty(err) && !isEmpty(err.response)) {
                const errors = err.response.data;

                if (!isEmpty(errors.captcha_token)) {
                    setFields(state => ({
                        ...state,
                        ['captcha']: {token: errors.captcha_token, require: true},
                        ['code']: {value: code, error: '', loading: false}
                    }));
                }

                if (!isEmpty(errors.errors)) {
                    setFields(state => ({
                        ...state,
                        ['code']: {value: code, error: 'کد رو اشتباه وارد کردید.', loading: false}
                    }));
                }
            }
        });
    };

    const handleLoginByPassword = (require_captcha = true) => {
        setFields(state => ({
            ...state,
            ['password']: {value: fields.password.value, error: '', loading: true},
            ['captcha_code']: {value: '', error: ''}
        }));

        const data = {
            username: getUsername().value,
            password: fields.password.value,
            captcha_code: fields.captcha.value
        };

        const rules = {
            password: 'required',
        };

        if (fields.captcha.require && require_captcha) {
            rules['captcha_code'] = 'required';
        }

        const validator = Validation(data, rules);
        validator.setAttributeNames({
            password: 'رمز عبور',
            captcha_code: 'کد تایید'
        });

        if (validator.fails()) {
            setFields(state => ({
                ...state,
                ['password']: {value: data.password, error: (typeof validator.errors.errors['password'] !== "undefined") ? 'رمز عبورتون رو وارد کنید.' : '', loading: false},
                ['captcha_code']: {value: data.password, error: (typeof validator.errors.errors['captcha_code'] !== "undefined") ? 'اعداد تصویر رو وارد کنید.' : '', loading: false},
            }));
        } else {

            loginByPassword(data).then(result => {
                userDispatcherContext({
                    type: 'STORE_USER',
                    payload: {
                        token: result.auth_token,
                        user: result.user
                    }
                });

                setShow(false);

                if (!isEmpty(callback)) {
                    callback(true);
                } else {
                    redirectToPanel(result.user)
                }
            }).catch(err => {
                if (!isEmpty(err) && !isEmpty(err.response)) {
                    const errors = err.response.data;

                    if (!isEmpty(errors.captcha_token)) {
                        setFields(state => ({
                            ...state,
                            ['captcha']: {token: errors.captcha_token, require: true},
                            ['password']: {value: fields.password.value, error: 'رمز عبورتون رو اشتباه وارد کردید.', loading: false}
                        }));
                    } else {
                        setFields(state => ({
                            ...state,
                            ['captcha']: {token: '', require: false},
                            ['password']: {value: fields.password.value, error: 'رمز عبورتون رو اشتباه وارد کردید.', loading: false}
                        }));
                    }
                }
            });
        }
    };

    const handleRegister = (to_level, send_code = false, send_register = false, code = '') => {
        if (!isEmpty(to_level) && to_level !== 'normal') {
            handleContinue(to_level);
        }

        if (send_code) {
            handleVerificationCode();
        } else if (send_register) {
            let data = {
                username: getUsername().value,
                verification_code: (!isEmpty(code) ? code : fields.code.value),
                type: fields.sing_up_type.value,
                city_id: fields.sign_up_realtor.value.city_id,
                district_id: fields.sign_up_realtor.value.district_id,
                last_name: fields.sign_up_realtor.value.name,
                agency_name: fields.sign_up_realtor.value.agency_name,
            };

            register(data).then(result => {
                userDispatcherContext({
                    type: 'STORE_USER',
                    payload: {
                        token: result.auth_token,
                        user: result.user
                    },
                });

                setShow(false);

                if (!isEmpty(callback)) {
                    callback(true);
                }
            }).catch(err => {
                if (!isEmpty(err) && !isEmpty(err.response)) {
                    const errors = err.response.data;

                    if (!isEmpty(errors.message)) {
                        setFields(state => ({
                            ...state,
                            ['code']: {value: code, error: 'کد وارد شده اشتباه است.', loading: false}
                        }));
                    }
                }
            });
        }
    };

    const handleForceRefreshCaptcha = () => {
        if (level.password) {
            handleLoginByPassword(false);
        } else if (level.code) {
            loginByCode(fields.code.value)
        }
    };

    return (
        <ModalLayout show={show} setShow={setShow} className={" " + (className ?? '')} modalDialogClass="modal-sm">
            <Container className="position-relative">
                <Mobile show={level.mobile}>
                    <HandleLoginHeader title="ورود یا ثبت‌نام" close={() => setShow(false)} back={() => handleContinue('mobile')}/>

                    <p className="mt-24 text-center">لطفا موبایل‌تون رو وارد کنید.</p>
                    <div className="form-group mb-0">
                        <Input type="tel" name="mobile" onChange={handleChange} value={formatToPhone(fields.mobile.value)} className={"form-control mt-24 " + (!isEmpty(fields.mobile.error) ? 'is-invalid' : '')} placeholder="مثلا ۰۹۱۲۱۲۳۴۵۶۷"/>
                        {
                            !isEmpty(fields.mobile.error) ?
                                <div className="invalid-feedback">
                                    {fields.mobile.error}
                                </div>
                                : ''
                        }
                    </div>

                    {
                        (level.mobile && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                            <Captcha
                                handleChange={handleChange}
                                token={fields.captcha.token}
                                error={fields.captcha_code.error}
                                captchaValue={fields.captcha.value}
                                handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                                className="mt-24"
                            />
                            : ''
                    }

                    <ButtonBase disabled={fields.mobile.loading} onClick={() => checkUserName()} color="secondary" block className={"mt-16 "}>
                        {
                            (fields.mobile.loading) ?
                                <CircleLoading width={24} height={24}/>
                                :
                                'ادامه'
                        }
                    </ButtonBase>

                    <p className="mt-40 mb-8 text-center">
                        قبلا با ایمیل ثبت‌نام کردید؟
                        <ButtonTransparent className="mr-8 text-secondary" onClick={() => handleContinue('email')}>ورود با ایمیل</ButtonTransparent>
                    </p>
                </Mobile>

                <Email show={level.email}>
                    <HandleLoginHeader title="ورود یا ثبت‌نام" close={() => setShow(false)} back={() => handleContinue('mobile')}/>

                    <p className="mt-24 text-center">لطفا ایمیل‌تون رو وارد کنید.</p>
                    <div className="form-group mb-0">
                        <Input type="email" name="email" onChange={handleChange} value={fields.email.value} className={"form-control mt-24 " + (!isEmpty(fields.email.error) ? 'is-invalid' : '')} placeholder="email@mail.com مثلا"/>
                        {
                            !isEmpty(fields.email.error) ?
                                <div className="invalid-feedback">
                                    {fields.email.error}
                                </div>
                                : ''
                        }
                    </div>

                    <ButtonBase disabled={fields.email.loading} onClick={() => checkUserName('email')} color="secondary" block className={"mt-16 "}>
                        {
                            (fields.email.loading) ?
                                <CircleLoading width={24} height={24}/>
                                :
                                'ادامه'
                        }
                    </ButtonBase>

                    <p className="mt-40 mb-8 text-center">
                        <ButtonTransparent className="text-secondary" onClick={() => handleContinue('mobile')}>ورود با موبایل</ButtonTransparent>
                    </p>
                </Email>

                <Password show={level.password}>
                    <HandleLoginHeader title="رمز عبور" close={() => setShow(false)} back={() => handleContinue('mobile')}/>

                    <p className="mt-24 text-center">لطفا رمز عبور‌تون رو وارد کنید.</p>
                    <div className="position-relative is-invalid-no-bg">
                        <Input
                            autoFocus={level.password}
                            type={passwordType}
                            name="password"
                            onChange={handleChange}
                            value={fields.password.value}
                            className={"form-control mt-24 " + (!isEmpty(fields.password.error) ? 'is-invalid' : '')}
                            placeholder=""/>
                        <Eyes>
                            <ButtonTransparent onClick={() => setPasswordType(((passwordType === 'password') ? 'text' : 'password'))}>
                                <Icon>
                                    {
                                        (passwordType === 'password') ?
                                            <EyeIcon/>
                                            :
                                            <EyeCloseIcon/>
                                    }
                                </Icon>
                            </ButtonTransparent>
                        </Eyes>

                        {
                            !isEmpty(fields.password.error) ?
                                <div className="invalid-feedback">
                                    {fields.password.error}
                                </div>
                                : ''
                        }
                    </div>

                    {
                        (level.password && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                            <Captcha
                                handleChange={handleChange}
                                token={fields.captcha.token}
                                error={fields.captcha_code.error}
                                captchaValue={fields.captcha.value}
                                handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                                className="mt-24"
                            />
                            : ''
                    }

                    <ButtonBase disabled={fields.password.loading} onClick={() => handleLoginByPassword()} color="secondary" block className={"mt-16 "}>
                        {
                            (fields.password.loading) ?
                                <CircleLoading width={24} height={24}/>
                                :
                                'ادامه'
                        }
                    </ButtonBase>

                    <div className="mt-40 mb-8 text-center">
                        {
                            (verificationCodeLoading) ?
                                <CircleLoading width={32} height={32}/>
                                :
                                (userType !== 'agent') ?
                                    <ButtonTransparent onClick={() => handleVerificationCode('code', true)} className="text-secondary ">
                                        {
                                            (userName !== 'email') ?
                                                'ورود با رمز پیامکی یکبار مصرف'
                                                :
                                                'ارسال کد به ایمیل'
                                        }
                                    </ButtonTransparent>
                                    : ''
                        }
                    </div>
                </Password>

                <Code
                    level={level}
                    show={show}
                    setShow={setShow}
                    fields={fields}
                    setFields={setFields}
                    handleVerificationCode={handleVerificationCode}
                    handleContinue={handleContinue}
                    getUsername={getUsername}
                    loginByCode={loginByCode}
                    handleChange={handleChange}
                    userExist={userExist}
                    handleRegister={handleRegister}
                    handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                />

                <ConfirmCaptcha
                    level={level}
                    setShow={setShow}
                    fields={fields}
                    setFields={setFields}
                    handleVerificationCode={handleVerificationCode}
                    handleContinue={handleContinue}
                    handleChange={handleChange}
                    handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                />

                <SignUpType
                    level={level}
                    show={show}
                    setShow={setShow}
                    setFields={setFields}
                    fields={fields}
                    handleContinue={handleContinue}
                    handleRegister={handleRegister}
                    handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                    handleCaptchaChange={handleChange}
                />

                <SignUpRealtor
                    level={level}
                    setShow={setShow}
                    fields={fields}
                    setFields={setFields}
                    handleContinue={handleContinue}
                    handleRegister={handleRegister}
                    handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                    handleCaptchaChange={handleChange}
                />
            </Container>
        </ModalLayout>
    )
}

export default React.memo(Login);

export const HandleLoginHeader = ({title, back, close, back_class}) => {
    return (
        <Header className="d-flex align-items-center justify-content-center">
            <Back onClick={back} className={(back_class) ? back_class : ''}>
                <Icon width="16" height="16">
                    <RightArrowIcon strokeWidth="2"/>
                </Icon>
            </Back>
            <h2>{title}</h2>
        </Header>
    )
};

// styles

const Container = styled.div`
  @media (max-width: ${props => props.theme.screenXsMax}) {
    padding-bottom: 24px;
  }
`;

const Password = styled.div`
  display: ${props => props.show ? 'block' : 'none'};
`;

const Input = styled.input`
  text-align: left;
  direction: ltr;

  &::placeholder {
    text-align: right;
  }
`;

const Back = styled(ButtonTransparent)`
  position: absolute;
  right: 0;
`;

const Close = styled(ButtonTransparent)`
  position: absolute;
  display: flex;
  left: 0;

  @media (max-width: ${props => props.theme.screenSmMax}) {
    display: none;
  }
`;


const Header = styled.div`
  line-height: 0;
`;

const Mobile = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

  ${Back} {
    display: none;
  }
`;

const Email = styled.div`
  display: ${props => props.show ? 'block' : 'none'};

  ${Back} {
    display: none;
  }
`;

const Eyes = styled.div`
  position: absolute;
  top: 0;
  right: 8px;
  transform: translate(-50%, 40%);

  .icons {
    width: 20px;

    svg {
      g, path {
        stroke-width: 1;
      }
    }
  }
`;